import React from 'react'
import { connect } from 'react-redux'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import moment from 'moment'
import ReactTooltip from 'react-tooltip';
import 'moment/locale/pt-br'
import '../../css/components/react-datepicker.css';
import pt from 'date-fns/locale/pt';
import { getPerfisVendedores } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarDataIda from '../../actions/origem/selecionarDataIda';
import buscarViagens from '../../actions/viagem/buscarViagens';
import selecionarViagem from '../../actions/viagem/selecionarViagem';
import limparViagens from '../../actions/viagem/limpaViagens';
import selecionarViagemIda from '../../actions/viagem/selecionarViagemIda';
import ImageGrid from '../veiculo/ImageGrid';
import Modal from '../veiculo/Modal';
import { campoBuscaTipoVeiculo } from '../../util/constantsUtil';

registerLocale('pt', pt);
setDefaultLocale('pt');

export class AbaItinerario extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedImg: null,
    };
  }

  limpaViagens(sentido) {
    if (sentido === 'pesquisaOrigem') this.props.selecionarOrigem(null);
    if (sentido === 'pesquisaDestino') this.props.selecionarDestino(null);
    this.props.selecionarViagem({});
    this.props.limparViagens();
  }

  buscarViagens() {
    this.props.selecionarViagem({});
    if (this.props.origem && this.props.destino) {
      this.props.buscarViagens(
        this.props.origem.id,
        this.props.destino.id,
        this.props.dataIda,
        null,
        this.props.empresaSelecionada.id,
        true,
        true,
        campoBuscaTipoVeiculo.TODOS.chave
      );
    }
  }

  calcularDuracao(viagem) {
    if (viagem.dataHoraPartida && viagem.dataHoraChegada) {
      const diff = Math.abs(new Date(viagem.dataHoraChegada) - new Date(viagem.dataHoraPartida));
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      return h > 0 ? `${h}h${m > 0 ? m + 'm' : ''}` : `${m}m`;
    }
    return '';
  }

  getCompanyInitials(nomeEmpresa) {
    if (!nomeEmpresa) return '?';
    const words = nomeEmpresa.trim().split(/\s+/);
    if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
    return nomeEmpresa.substring(0, 2).toUpperCase();
  }

  setSelectedImg(selectedImg) {
    this.setState({ selectedImg });
  }

  estaSelacionada(viagem) {
    return this.props.viagem && this.props.viagem.idItinerario === viagem.idItinerario;
  }

  exibirCalendario() {
    let data;
    if (this.props.dataIda) {
      data = moment(this.props.dataIda).toDate();
    }
    return (
      <div className="linha">
        <DatePicker
          className="form-control form-control-lg campo-busca"
          placeholderText="Data de Saída"
          value={data}
          minDate={new Date()}
          locale="pt-BR"
          selected={data}
          onChange={(date) => { this.props.selecionarDataIda(date); this.limpaViagens('data'); }}
          dateFormat="dd/MM/yyyy"
          withPortal
        />
      </div>
    );
  }

  exibirItinerario(passagens) {
    if (passagens && passagens.length) {
      return (
        <React.Fragment>
          <div className="vx-trip-section-label">ITINERÁRIOS DISPONÍVEIS</div>
          <div className="vx-trip-list">
            {passagens
              .sort((a, b) => new Date(a.dataHoraPartida) - new Date(b.dataHoraPartida))
              .map((viagem, index) => {
                const chegada = viagem.dataHoraChegada ? new Date(viagem.dataHoraChegada) : null;
                const arrivalTime = chegada
                  ? chegada.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
                  : '--:--';
                const arrivalDate = chegada
                  ? chegada.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' }).replace('.', '')
                  : '';
                const duracao = this.calcularDuracao(viagem);
                const initials = this.getCompanyInitials(viagem.nomeEmpresa);
                const selecionada = this.estaSelacionada(viagem);
                return (
                  <div
                    key={`${viagem.idItinerario}-${index}`}
                    className={`vx-trip-card vx-trip-card--enc${selecionada ? ' vx-trip-card--selected' : ''}`}
                    onClick={() => this.props.selecionarViagem(viagem)}
                    style={{ cursor: 'pointer' }}
                  >
                    {/* Empresa */}
                    <div className="vx-tc-company">
                      <div className="vx-tc-badge">{initials}</div>
                      <div className="vx-tc-company-detail">
                        <span className="vx-tc-company-name">{viagem.nomeEmpresa}</span>
                        <span className="vx-tc-route">{viagem.descRota}</span>
                      </div>
                    </div>

                    {/* Horários */}
                    <div className="vx-tc-times">
                      <div className="vx-tc-time-block">
                        <span className="vx-tc-hour">{viagem.horaPartida}</span>
                        <span className="vx-tc-date">{viagem.dataPartida}</span>
                      </div>
                      <div className="vx-tc-arrow">
                        <div className="vx-tc-arrow-line"></div>
                        {duracao && <span className="vx-tc-duration">{duracao}</span>}
                      </div>
                      <div className="vx-tc-time-block">
                        <span className="vx-tc-hour">{arrivalTime}</span>
                        {arrivalDate && <span className="vx-tc-date">{arrivalDate}</span>}
                      </div>
                    </div>

                    {/* Embarque */}
                    <div className="vx-tc-boarding">
                      <i className="material-icons">place</i>
                      <span
                        data-tip
                        data-for={`embarque-enc-${viagem.idItinerario}`}
                        className="vx-tc-boarding-text"
                      >
                        {viagem.embarque}
                      </span>
                      <ReactTooltip
                        id={`embarque-enc-${viagem.idItinerario}`}
                        type="dark"
                        effect="solid"
                        place="top"
                      >
                        {viagem.embarque}
                      </ReactTooltip>
                    </div>

                    {/* Veículo — imagem (coluna própria) */}
                    <div className="vx-tc-vehicle-img">
                      <ImageGrid
                        setSelectedImg={this.setSelectedImg.bind(this)}
                        veiculo={viagem.imagemVeiculo}
                        tipoVeiculo={viagem.tipoImagemVeiculo}
                      />
                      {this.state.selectedImg && (
                        <Modal
                          selectedImg={this.state.selectedImg}
                          setSelectedImg={this.setSelectedImg.bind(this)}
                        />
                      )}
                    </div>

                    {/* Veículo — info (coluna própria) */}
                    <div className="vx-tc-vehicle-info">
                      <span className="vx-tc-category">{viagem.descricaoTipoVeiculo}</span>
                      <span className="vx-tc-vehicle-name">{viagem.veiculo}</span>
                      {viagem.nomePrestador && (
                        <span className="vx-tc-prestador">{viagem.nomePrestador}</span>
                      )}
                    </div>

                    {/* Botão selecionar / avançar inline */}
                    {selecionada ? (
                      <button
                        className="vx-tc-select vx-tc-select--avancar"
                        onClick={e => { e.stopPropagation(); this.props.avancar && this.props.avancar(); }}
                      >
                        Avançar
                        <i className="material-icons" style={{ fontSize: 16, verticalAlign: 'middle' }}>arrow_forward</i>
                      </button>
                    ) : (
                      <button
                        className="vx-tc-select"
                        onClick={e => { e.stopPropagation(); this.props.selecionarViagem(viagem); }}
                      >
                        Selecionar
                      </button>
                    )}

                    {/* Rodapé: Itinerário */}
                    <div className="vx-tc-footer">
                      <span className="vx-tc-footer-item">
                        <span className="vx-tc-footer-label">Itinerário</span>
                        <span className="vx-tc-footer-value">{viagem.idItinerario}</span>
                      </span>
                      {viagem.idRota && (
                        <>
                          <span className="vx-tc-footer-sep">·</span>
                          <span className="vx-tc-footer-item">
                            <span className="vx-tc-footer-label">Rota</span>
                            <span className="vx-tc-footer-value">{viagem.idRota}</span>
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        </React.Fragment>
      );
    }
    if (passagens) {
      return (
        <div className="alert alert-warning text-center mt-4" role="alert">
          Nenhum resultado encontrado para sua pesquisa.
        </div>
      );
    }
  }

  render() {
    return (
      <Autorizacao perfisPermitidos={[...getPerfisVendedores(this.props.empresaSelecionada.id)]}>
        <div className="col-12">
          <div className="vx-search-card">
            <div className="vx-search-grid">
              <div className="vx-search-field">
                <label className="vx-search-label">Origem</label>
                <SelecaoCidadeAutocomplete
                  nome="pesquisaOrigem"
                  name="pesquisaOrigem"
                  limparViagens={this.limpaViagens.bind(this)}
                  placeholder="Cidade origem"
                  ehVenda={true}
                  selecionarCidade={this.props.selecionarOrigem}
                  value={this.props.origem}
                />
              </div>
              <div className="vx-search-field">
                <label className="vx-search-label">Destino</label>
                <SelecaoCidadeAutocomplete
                  nome="pesquisaDestino"
                  name="pesquisaDestino"
                  ehVenda={true}
                  limparViagens={this.limpaViagens.bind(this)}
                  placeholder="Cidade destino"
                  selecionarCidade={this.props.selecionarDestino}
                  value={this.props.destino}
                />
              </div>
              <div className="vx-search-field">
                <label className="vx-search-label">Data de Saída</label>
                {this.exibirCalendario()}
              </div>
              <button
                className="vx-btn-buscar"
                onClick={() => this.buscarViagens()}
                disabled={!this.props.origem || !this.props.destino || !this.props.dataIda}
              >
                <i className="material-icons">search</i>
                Buscar
              </button>
            </div>
          </div>
          {this.exibirItinerario(this.props.viagens.passagensIda)}
        </div>
      </Autorizacao>
    );
  }
}

export const mapStateToProps = state => ({
  origem: state.origem,
  destino: state.destino,
  dataIda: state.dataIda,
  viagens: state.viagens,
  empresaSelecionada: state.empresaSelecionada,
  viagem: state.viagem,
});

export default connect(mapStateToProps, {
  selecionarDestino,
  selecionarOrigem,
  selecionarDataIda,
  buscarViagens,
  selecionarViagem,
  limparViagens,
  selecionarViagemIda,
})(AbaItinerario);
